<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-sales-rank">
        <div class="card-body" style="min-height: 200px">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <button
              class="btn btn-icon text-white"
              :class="ranks.show_previous_month_button ? 'btn-navigation' : 'btn-secondary'"
              @click="viewPreviousMonth(ranks.show_previous_month_button)"
            >
              <i class="fa fa-angle-left"></i>
            </button>

            <h4 v-if="!isLoading" class="card-title mb-0">
              Ranking Top Sales On {{ formattedPeriod(currentMonth, currentYear, true) }}
            </h4>

            <button
              class="btn btn-icon text-white"
              :class="ranks.show_next_month_button ? 'btn-navigation' : 'btn-secondary'"
              @click="viewNextMonth(ranks.show_next_month_button)"
            >
              <i class="fa fa-angle-right"></i>
            </button>
          </div>

          <div v-if="isLoading" class="text-center">
            <span>Loading...</span>
          </div>

          <div v-else>
            <table class="table table-sales-rank">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Consultant Name</th>
                  <th class="text-center">Closed</th>
                  <th class="text-center">Referrer</th>
                  <th class="text-center">Key Partner</th>
                  <th class="text-center">Hunter/Eventos</th>
                  <th class="text-center">Rating</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="rank in ranks.ranking"
                  :key="rank.id"
                  :class="{
                    'top-five': rank.badge !== null,
                    'managed-consultant': isManagedConsultant(rank.id)
                  }"
                >
                  <td class="text-center">
                    <strong>{{ rank.rank }}</strong>
                  </td>
                  <td class="rank-badge text-center">
                    <img
                      v-if="rank.badge"
                      :src="`/images/icons-rank/${rank.badge}.svg`"
                      class="img-xs" :alt="rank.name"
                    />
                    <span v-else></span>
                  </td>
                  <td class="rank-consultant">
                    <img :src="`${rank.image}`" class="img-circle mr-2" :alt="`${rank.name}`" />
                    <strong>{{ rank.name }}</strong>
                  </td>
                  <td class="text-center"><strong>{{ rank.closed }}</strong></td>
                  <td class="text-center">{{ rank.referrer }}</td>
                  <td class="text-center">{{ rank.key_partner }}</td>
                  <td class="text-center">{{ rank.hunter_and_event }}</td>
                  <td class="text-center">
                    <p class="mb-0">{{ rank.avg_rating }}</p>
                    <Rating :rating="rank.avg_rating" />
                    <p>
                      <small class="font-weight-bold font-italic">
                        ({{
                          rank.total_review > 1
                              ? rank.total_review + ' Reviews'
                              : rank.total_review === 1
                                  ? rank.total_review + ' Review'
                                  : 'No Review'
                        }})
                      </small>
                    </p>

                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th></th>
                  <th></th>
                  <th>TOTAL</th>
                  <th>{{ ranks.totals.total_closed }}</th>
                  <th>{{ ranks.totals.total_referrer }}</th>
                  <th>{{ ranks.totals.total_key_partner_schools }}</th>
                  <th>{{ ranks.totals.total_hunters_and_events }}</th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSalesRank } from "../../services/api/goals";
import { formatPeriod } from "../../utils/helpers";
import Rating from "../../components/Rating.vue";

import '../../../sass/sales-rank.scss';

export default {
  name: 'SalesRankSection',
  components: { Rating },
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.fetchSalesRank();
  },
  data() {
    return {
      isLoading: false,
      isManaged: [],
      ranks: {
        ranking: [],
        totals: {
          total_closed: 0,
          total_referrer: 0
        },
        show_previous_month_button: false,
        show_next_month_button: false
      },
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear()
    };
  },
  computed: {
    managedConsultantIds() {
      const ids = [];
      this.ranks.ranking.forEach(rank => {
        if (rank.marker && rank.marker.is_managed_consultant) {
          rank.marker.is_managed_consultant.forEach(consultant => {
            ids.push(consultant.id);
          });
        }

        if (rank.marker.is_logged_in_user) {
          ids.push(this.userId);
        }
      });

      return ids;
    }
  },
  methods: {
    formattedPeriod(month, year, mode = false) {
      return formatPeriod(month, year, mode);
    },
    async fetchSalesRank(month = this.currentMonth, year = this.currentYear) {
      this.isLoading = true;

      try {
        const payload = {
          month: month,
          year: year
        }

        const response = await getSalesRank(payload);

        if (response.status === 200) {
          this.ranks = response.data;
          this.currentMonth = month;
          this.currentYear = year;
        }
      } catch (error) {
        console.error('Error fetching sales rank: ', error);
      } finally {
        this.isLoading = false;
      }
    },
    viewPreviousMonth(show) {
      if (show) {
        let month = this.currentMonth - 1;
        let year = this.currentYear;

        if (month < 1) {
          month = 12;
          year -= 1;
        }

        this.fetchSalesRank(month, year);
      }
    },
    viewNextMonth(show) {
      if (show) {
        let month = this.currentMonth + 1;
        let year = this.currentYear;

        if (month > 12) {
          month = 1;
          year += 1;
        }

        this.fetchSalesRank(month, year);
      }
    },
    isManagedConsultant(userId) {
      return this.managedConsultantIds.includes(userId);
    }
  }
}
</script>